export const inspectTemplateRoute = (
  docType: string,
  regionCode: string,
  docId: string,
  revId?: string
) => ({
  pathname: `/inspect/${docType}/${regionCode}/${docId}`,
  search: revId ? `?revId=${revId}` : undefined,
});

export const visualizeDocumentRoute = (
  docType: string,
  regionCode: string,
  docId: string
) => ({
  pathname: `/visualize/${docType}/${regionCode}/${docId}`,
});
